"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

function resolveBucketEndpointConfig(input) {
  var _a = input.bucketEndpoint,
      bucketEndpoint = _a === void 0 ? false : _a,
      _b = input.forcePathStyle,
      forcePathStyle = _b === void 0 ? false : _b,
      _c = input.useAccelerateEndpoint,
      useAccelerateEndpoint = _c === void 0 ? false : _c,
      _d = input.useDualstackEndpoint,
      useDualstackEndpoint = _d === void 0 ? false : _d;
  return tslib_1.__assign(tslib_1.__assign({}, input), {
    bucketEndpoint: bucketEndpoint,
    forcePathStyle: forcePathStyle,
    useAccelerateEndpoint: useAccelerateEndpoint,
    useDualstackEndpoint: useDualstackEndpoint
  });
}

exports.resolveBucketEndpointConfig = resolveBucketEndpointConfig;